(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PurchasePresentItemLot', PurchasePresentItemLot);

    PurchasePresentItemLot.$inject = ['$resource'];

    function PurchasePresentItemLot ($resource) {
        var resourceUrl =  'api/purchase-present-item-lots/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
